import { Auth } from '@common/Auth'
import { getBuyIcon } from '@components/LocalMerchant/Decoration/util'
import {
  DECORATION_MERCHANT_PROMISE,
  PRIVILEGE_GROUP_ID,
  PRIVILEGE_NORMAL_ID,
  PRIVILEGE_NORMAL_SERVICE_ID,
  PRIVILEGE_PROMISE_ID,
  PRIVILEGE_REFUND_ID,
  PROMISE_STATUS_FAIL,
  PROMISE_STATUS_PADDING
} from '@constant'
import { dGet } from '@core/utils'
import { isNormal } from '@merchant-backend/util'
import { getMerchantInfo, isSiDaTeam } from '@util'
import { Flex } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Arrow from '../Common/Arrow'
import Rowbox from '../Common/Rowbox'
import style from './index.module.less'

@Auth({
  role: [PRIVILEGE_NORMAL_ID, PRIVILEGE_NORMAL_SERVICE_ID, PRIVILEGE_GROUP_ID]
})
@observer
export default class extends Component {
  getStatus = () => {
    const { allStatus } = this.props.store
    let status = ''
    const privileges = dGet(allStatus, 'privileges', [])
    const promise = privileges.find(item => +item.id == PRIVILEGE_PROMISE_ID)
    const refund = privileges.find(item => +item.id == PRIVILEGE_REFUND_ID)
    if (promise && refund) {
      if (
        promise.status == PROMISE_STATUS_PADDING ||
        refund.status == PROMISE_STATUS_PADDING
      ) {
        status = 'verifying'
      } else if (
        promise.status == PROMISE_STATUS_FAIL ||
        refund.status == PROMISE_STATUS_FAIL
      ) {
        status = 'rejected'
      }
    }
    return status
  }

  getMerchantPromise = (list = [], mode, promiseIcon) => {
    const { allStatus, newThemeConfig } = this.props.store
    const showAll = this.props.showAll || false
    const privileges = dGet(allStatus, 'privileges', [])
    const promise = privileges.find(item => +item.id == PRIVILEGE_PROMISE_ID)
    // 普通版商家 只显示放心购
    const normalFunnyBuy = !showAll && mode === 'preview' && isNormal()

    return (
      <span style={{ color: newThemeConfig['moduleTitle'] }}>
        {mode !== 'preview'
          ? promise && promise.status == PROMISE_STATUS_FAIL
            ? '请设置商家承诺'
            : list.length
              ? list.map((el, i) => (
                  <span key={i}>
                    <span>
                      <img className={style.promiseIcon} src={promiseIcon} />
                    </span>
                    <span className={style.promiseItem}>{el}</span>
                  </span>
                ))
              : '请设置商家承诺'
          : normalFunnyBuy
            ? '该商家已加入放心购计划'
            : promise && promise.status == PROMISE_STATUS_FAIL
              ? ''
              : list.length
                ? list.map((el, i) => (
                    <span key={i}>
                      <span>
                        <img className={style.promiseIcon} src={promiseIcon} />
                      </span>
                      <span className={style.promiseItem}>{el}</span>
                    </span>
                  ))
                : ''}
      </span>
    )
  }

  getMerchantChargeBack = (list, mode) => {
    list = list || []
    const { allStatus, newThemeConfig } = this.props.store
    const privileges = dGet(allStatus, 'privileges', [])
    const refund = privileges.find(item => +item.id == PRIVILEGE_REFUND_ID)
    const text = isSiDaTeam()
      ? list.map(item => `${getMerchantInfo().name}承诺${item}`).join('·')
      : list.join('·')

    return (
      <span
        className={style.contentChargeBack}
        style={{ color: newThemeConfig['moduleTitle'] }}
      >
        {mode !== 'preview'
          ? refund && refund.status == PROMISE_STATUS_FAIL
            ? '请设置订单可退'
            : list.length
              ? text
              : '请设置订单可退'
          : refund && refund.status == PROMISE_STATUS_FAIL
            ? ''
            : list.length
              ? text
              : ''}
      </span>
    )
  }

  render() {
    const status = this.getStatus()
    const {
      mode,
      promiseData,
      videoData,
      themeConfig,
      newThemeConfig,
      theme
    } = this.props.store

    const emptyVideo = !dGet(videoData, 'cover_path', '')

    const merchantPromise =
      dGet(promiseData, 'privilege.merchant_promise', []) || []
    const showAll = this.props.showAll || false
    const merchantChargeBack =
      dGet(promiseData, 'privilege.charge_back', []) || []
    const isModuleShow =
      mode === 'editable' ||
      (mode === 'preview' &&
        (merchantPromise.length || merchantChargeBack.length))
    // 普通版商家 只显示放心购
    const normalFunnyBuy = !showAll && mode === 'preview' && isNormal()

    return isModuleShow ? (
      <Rowbox
        type={DECORATION_MERCHANT_PROMISE}
        store={this.props.store}
        style={{
          height: 'auto',
          flexDirection: 'column',
          marginBottom: 0
        }}
        status={status}
        vCenter={false}
      >
        <Flex
          sp
          vc
          className={style.promise}
          style={{
            ...(mode === 'preview' && emptyVideo
              ? {
                  borderRadius: 0,
                  boxShadow: 'none'
                }
              : {}),
            borderBottom: `1px solid ${newThemeConfig['splitLine']}`
          }}
        >
          <div className={style.content}>
            <div
              className={style.contentPromise}
              style={{
                marginTop: normalFunnyBuy ? 10 : 0
              }}
            >
              {getMerchantInfo().is_bond == 1 && (
                <img className={style.logo} src={getBuyIcon(theme)} />
              )}
              {this.getMerchantPromise(
                merchantPromise,
                mode,
                themeConfig['promiseIcon']
              )}
            </div>
            {normalFunnyBuy ? null : (
              <div className={style.contentChargeBack}>
                {this.getMerchantChargeBack(merchantChargeBack, mode)}
              </div>
            )}
          </div>

          <Arrow />
        </Flex>
      </Rowbox>
    ) : null
  }
}
